import { FC, useEffect } from "react";
import Divider from "Components/Divider";
import { useState } from "react";
import Post from "./Post";
import {
  DividerWrapper,
  PaginationWrapper,
  PostsWrapper,
} from "./Posts.styled";
import { PostInterface } from "./Posts.types";
import Axios from "axios";
import Button from "Components/Button";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";

interface Props {
  id: string;
}

const Posts: FC<Props> = ({ id }) => {
  const [posts, setPosts] = useState([]);
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState(1);

  const fetchPosts = async () => {
    const posts = await Axios.get(`/api/liveblog?id=${id}&offset=${offset}`);
    setStatus(posts.data.data.status);
    setTotal(posts.data.paging.postsIds.length);
    setPosts([]);
    setPosts(posts.data.posts);
  };

  useEffect(() => {
    fetchPosts();
  }, [offset]);
  useEffect(() => {
    let id = setInterval(() => {
      fetchPosts();
    }, 60000);
    return () => clearInterval(id);
  });

  if (!posts) {
    return null;
  }

  const decrement = () => {
    if (offset > 0) {
      setOffset(offset - 10);
    }
  };

  const increment = () => {
    if (offset + 10 < total) {
      setOffset(offset + 10);
    }
  };

  return (
    <>
      <PostsWrapper>
        {posts?.map((post: PostInterface, i: number) => {
          return (
            <div key={i}>
              <Post post={post} />
              {i !== posts.length - 1 && (
                <DividerWrapper>
                  <Divider direction="verticle" />
                </DividerWrapper>
              )}
            </div>
          );
        })}
      </PostsWrapper>
      <PaginationWrapper>
        <Button
          disabled={offset === 0}
          buttonStyles="pagination"
          handleClick={decrement}
          lefticon={<AiOutlineArrowLeft />}
        >
          {status === 1 ? "Latest updates" : "Older updates"}
        </Button>
        &nbsp; &nbsp;
        <Button
          disabled={offset + 10 > total}
          buttonStyles="pagination"
          handleClick={increment}
          icon={<AiOutlineArrowRight />}
        >
          {status === 1 ? "Older updates" : "Latest updates"}
        </Button>
      </PaginationWrapper>
    </>
  );
};

export default Posts;
